// src/CitySelectorDropdown.js
import React, { useState, useEffect, useRef } from 'react';
import '../styles/CitySelectorDropdown.css'; // We will create this CSS file

const CitySelectorDropdown = ({ maps, currentMapId, currentMapName, onMapChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (mapId) => {
    onMapChange(mapId);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="city-selector-dropdown" ref={dropdownRef}>
      <button className="dropdown-toggle-btn" onClick={toggleDropdown} aria-haspopup="true" aria-expanded={isOpen}>
        <span>{currentMapName || 'Select Location'}</span>
        <svg className={`dropdown-arrow ${isOpen ? 'open' : ''}`} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {maps.map(map => (
            <li key={map.id} className={map.id === currentMapId ? 'active' : ''}>
              <button onClick={() => handleSelect(map.id)}>
                {map.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CitySelectorDropdown;